export default {
	api: 'http://localhost:3001',
	google_analytics: 'UA-85433452-6',
	callback_url: {
		payment: {
			white_label: 'http://localhost:4000/callback/payment?product_slug=white_label',
			email_plus: 'http://localhost:4000/callback/payment?product_slug=email_plus'
		}
	}
};



// WEBPACK FOOTER //
// ./src/config/environment/development.js